import React,{ useState, useEffect, useRef } from "react";
import LogoImg from "../images/prelogin-img/logo-stolity.svg";
import heroVideo from "../images/prelogin-img/hero-video.mp4";
import aboutGift from "../images/prelogin-img/about-gift.gif";
import upload from "../images/prelogin-img/upload-icon.svg";
import share from "../images/prelogin-img/share-icon.svg";
import privacy from "../images/prelogin-img/privacy-icon.svg";
import work from "../images/prelogin-img/work-icon.svg";
import card1 from "../images/prelogin-img/card-1.jpg";
import card2 from "../images/prelogin-img/card-2.jpg";
import card3 from "../images/prelogin-img/card-3.jpg";
import bannerImg from "../images/prelogin-img/banner-img.png";
import full from "../images/prelogin-img/full.svg";
import { useNavigate } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";

const PreLogin = () => {
  const [isAnnual, setIsAnnual] = useState(false);
  const videoRef = useRef(null);
  const navigate = useNavigate();

  // Login Navigation
  const handleNavigation = (e) => {
    e.preventDefault();
    navigate("/Login");
  };

  // Animatiom
  useEffect(() => {
    AOS.init({
      duration: 1000,
      offset: 100,
      easing: "ease-in-out",
      once: true,
    });
  }, []);

  // Card Scrolling
  const cardContainerRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      const container = cardContainerRef.current;
      if (!container) return;

      const sectionTop = container.offsetTop;
      const sectionHeight = container.offsetHeight;
      const scrollPosition = window.scrollY;
      const windowHeight = window.innerHeight;

      const progress =
        (scrollPosition - sectionTop + windowHeight * 0.5) / sectionHeight;

      if (progress >= 0 && progress <= 1) {
        const maxScroll = container.scrollHeight - container.clientHeight;

        // Improved scroll behavior with balanced speed and smoothness
        const easedProgress = Math.pow(progress, 1.3); // Smoother acceleration curve
        container.scrollTop = easedProgress * maxScroll * 4.5; // Slightly reduced speed
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Full Screen Video
  const handleFullScreen = () => {
    if (videoRef.current) {
      if (videoRef.current.requestFullscreen) {
        videoRef.current.requestFullscreen();
      } else if (videoRef.current.webkitRequestFullscreen) {
        // Safari
        videoRef.current.webkitRequestFullscreen();
      } else if (videoRef.current.msRequestFullscreen) {
        // IE/Edge
        videoRef.current.msRequestFullscreen();
      }
    }
  };

  //  Price Card Data
  const monthlyPlans = [
    { name: "Bronze", price: 250, discount: "Save 10%" },
    { name: "Silver", price: 250, discount: "Save 15%" },
    { name: "Gold", price: 250, discount: "Save 25%" },
  ];

  const annualPlans = [
    { name: "Bronze", price: 225, discount: "Save 20%" },
    { name: "Silver", price: 212, discount: "Save 50%" },
    { name: "Gold", price: 188, discount: "Save 45%" },
  ];

  const plans = isAnnual ? annualPlans : monthlyPlans;

  return (
    <>
      <header data-aos="zoom-out">
        <div className="header-content content">
          <a href="#">
            <img src={LogoImg} alt="logo" className="img-fluid" />
          </a>

          <div className="header-btns">
            <div class="dropdown custom-dropdown">
              <button
                class="btn dropdown-toggle"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                Try Stolity for Work
              </button>
              <ul class="dropdown-menu">
                <li>
                  <a class="dropdown-item" href="#">
                    Option 1
                  </a>
                </li>
                <li>
                  <a class="dropdown-item" href="#">
                    Option 2
                  </a>
                </li>
                <li>
                  <a class="dropdown-item" href="#">
                    Option 3
                  </a>
                </li>
              </ul>
            </div>

            <a href="#" className="get-start-btn" onClick={handleNavigation}>
              Get Started
            </a>
          </div>
        </div>
      </header>

      <main>
        <section className="hero-img" data-aos="zoom-out">
          <div className="content">
            <div className="hero-content">
              <h5>Upload. Organize. Share. Anytime, Anywhere.</h5>
              <h1>
                Effortless File Storage & Secure <br />
                Sharing with Stolity
              </h1>
              <p className="pre-para">
                Stolity is a powerful cloud-based file management platform that
                allows you to upload, organize, and share files seamlessly. With
                high-speed uploads up to 5GB, advanced security features, and
                intuitive sharing options, managing files has never been this
                easy.
              </p>
            </div>

            {/* -- video -- */}
            <div className="hero-video">
              <video
                ref={videoRef}
                src={heroVideo}
                autoPlay
                loop
                muted
                controls
              ></video>
              <div className="full-screen-content">
                <h6>
                  <b>Full Screen Mode</b>
                </h6>
                <img
                  src={full}
                  alt="full"
                  className="fullscreen-btn"
                  onClick={handleFullScreen}
                />
              </div>
            </div>
          </div>
        </section>

        {/* --- Intro Section --- */}
        <section data-aos="zoom-in">
          <div className="content">
            <div className="row">
              <div className="left-intro col-12 col-lg-6">
                <p className="pre-para semibold">Effortless File Management</p>
                <h2>
                  Your{" "}
                  <span>
                    Smartest File <br />
                    Management
                  </span>
                  <br />
                  Companion
                </h2>
              </div>

              <div className="right-intro col-12 col-lg-6">
                <p className="pre-para">
                  <b>Imagine this</b>: You’re working on an important project,
                  juggling multiple files across different devices. You need a
                  secure, seamless, and intuitive way to manage, share, and
                  access your files. That’s where Stolity comes in.
                  <br />
                  <br />
                  With Stolity, <b>your files move as fast as your ideas—</b>
                  effortlessly uploaded, neatly organized, and instantly
                  accessible from anywhere.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* --- About Section --- */}
        <section>
          <div className="content">
            <div className="row">
              <div className="about-left col-12 col-lg-6">
                <img src={aboutGift} alt="About Gift" />
              </div>

              <div
                className="about-right col-12 col-lg-6"
                ref={cardContainerRef}
              >
                <div className="about-card-container">
                  <div className="about-card">
                    <img src={upload} alt="upload" className="img-fluid" />
                    <h4>Upload Without Limits</h4>
                    <p>
                      No more waiting. Stolity lets you upload files up to 5GB
                      in seconds, even while multitasking.
                    </p>
                  </div>

                  <div className="about-card mt-4">
                    <img src={share} alt="upload" className="img-fluid" />
                    <h4>Share with Confidence</h4>
                    <p>
                      Generate short links, QR codes, or email invitations—all
                      with custom access settings.
                    </p>
                  </div>

                  <div className="about-card mt-4">
                    <img src={privacy} alt="upload" className="img-fluid" />
                    <h4>Your Privacy, Our Priority</h4>
                    <p>
                      Password-protect sensitive files, set expiration dates,
                      and track access logs—all in one secure dashboard.
                    </p>
                  </div>

                  <div className="about-card mt-4">
                    <img src={work} alt="upload" className="img-fluid" />
                    <h4>Work from Anywhere</h4>
                    <p>
                      Whether on your desktop, tablet, or phone, Stolity keeps
                      your workflow uninterrupted.
                    </p>
                  </div>

                  <div className="about-card mt-4">
                    <img src={work} alt="upload" className="img-fluid" />
                    <h4>Work from Anywhere</h4>
                    <p>
                      Whether on your desktop, tablet, or phone, Stolity keeps
                      your workflow uninterrupted.
                    </p>
                  </div>
        
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* --- Services Card Section --- */}
        <section data-aos="zoom-in">
          <div className="content">
            <div className="card-heading">
              <p className="pre-para semibold">
                An Experience Built for Everyone
              </p>
              <h2>
                Designed for{" "}
                <span>
                  Accessibility & <br />
                  User Experience
                </span>
              </h2>
            </div>

            <div className="row">
              <div className="services-card col-12 col-lg-4">
                <div class="card">
                  <img src={card1} class="card-img-top" alt="card" />
                  <div class="card-body">
                    <h5 class="card-title">Light & Dark Mode</h5>
                    <p class="card-text">
                      Customize your experience for optimal comfort. Because
                      your workspace should adjust to you, not the other way
                      around.
                    </p>
                  </div>
                </div>
              </div>

              <div className="services-card col-12 col-lg-4">
                <div class="card">
                  <img src={card2} class="card-img-top" alt="card" />
                  <div class="card-body">
                    <h5 class="card-title">
                      Microinteractions that Make a Difference
                    </h5>
                    <p class="card-text">
                      Thoughtfully designed animations enhance usability. Every
                      click, hover, and transition is designed to be smooth and
                      intuitive.
                    </p>
                  </div>
                </div>
              </div>

              <div className="services-card col-12 col-lg-4">
                <div class="card">
                  <img src={card3} class="card-img-top" alt="card" />
                  <div class="card-body">
                    <h5 class="card-title">Available on Both Web & Mobile</h5>
                    <p class="card-text">
                      Seamless experience across all devices.So you can manage
                      your files anywhere, anytime.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* --- Offers Card Section --- */}
        <section data-aos="zoom-in">
          <div className="content">
            <div className="card-heading">
              <p className="pre-para semibold">Our Portable Pricing System</p>
              <h2>
                Here is our <span>Pricing Plan</span>
              </h2>
            </div>

            <div className={`offer-btn-wrape ${isAnnual ? "active" : ""}`}>
              <a
                className={!isAnnual ? "active" : ""}
                onClick={() => setIsAnnual(false)}
              >
                Monthly
              </a>
              <a
                className={isAnnual ? "active" : ""}
                onClick={() => setIsAnnual(true)}
              >
                Annually
              </a>
            </div>

            <div className="row g-4" data-aos="zoom-in">
              {plans.map((plan, index) => (
                <div key={index} className="offer-card-container col-lg-4">
                  <div className="offer-card">
                    <div className="d-flex justify-content-between">
                      <h4 className="offer-palne-name">{plan.name}</h4>
                      <a href="#" className="check">
                        <i class="fa-solid fa-check"></i>
                      </a>
                    </div>
                    <div className="offer-badge-wrape mt-3">
                      <span className="offer-badge">{plan.discount}</span>
                    </div>
                    <h4 className="offer-price text-right">₹{plan.price}.00</h4>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* --- Banner Section --- */}
        <section data-aos="zoom-in">
          <div className="content">
            <div className="row main-banner">
              <div className="banner-left col-12 col-lg-6">
                <h2>
                  <span>Seamless Productivity</span>
                  <br />
                  with Stolity
                </h2>
                <p className="pre-para">
                  No more clutter. No more chaos. Just pure efficiency at your
                  fingertips.
                  <br />
                  <br />
                  We are available on both the App Store and Play Store.
                </p>
                <a href="#" className="organize-btn">
                  Start Organizing Smarter
                  <i class="fa-solid fa-arrow-right"></i>
                </a>

                <div className="banner-btns">
                  <a href="#" className="play-btn">
                    <i class="fa-brands fa-google-play"></i>
                    Get App on Play Store
                  </a>
                  <a href="#" className="apple-btn">
                    <i class="fa-brands fa-apple"></i>
                    Get App on Apple Store
                  </a>
                </div>
              </div>

              <div className="banner-right col-12 col-lg-6">
                <img src={bannerImg} alt="banner" className="img-fluid" />
              </div>
            </div>
          </div>
        </section>
      </main>

      <footer className="content" data-aos="zoom-in">
        <p>© 2025 Stolity. All rights reserved.</p>

        <ul className="footer-right">
          <li>
            <a href="#">Terms of Service</a>
          </li>
          <li>
            <a href="#">Privacy Policy</a>
          </li>
          <li>
            <a href="#">Cookies</a>
          </li>
        </ul>
      </footer>
    </>
  );
};

export default PreLogin;
